import React, { useCallback, memo } from "react";
import { shallowEqual } from "react-redux";
import { DefaultRootState } from "stores";
import { useAppDispatch, useAppSelector } from "stores";
import styled from "styled-components";
import store from "stores/interfaces";

import { Dialog, DialogContent } from "@mui/material";
import { TwitterPicker as _TwitterPicker } from "react-color";
import * as material from "material-colors";
import { addUndoUpdateCharacter } from "stores/modules/entities.room.characters/operations";

// const dialogContentStyle = { padding: 0, background: "rgba(0, 0, 0, 0.12)" };
// const primaryTypographyProps = { variant: "caption" };

// TODO: fix @types/react-color
const TwitterPicker = _TwitterPicker as any;

const selectColorPickerState = (state: DefaultRootState) => {
  const characterId = store.getUserCharacterId(state);
  const character = store.getRoomChatCharacter(state);
  const pickedColor = !!character
    ? character.color || "#888888"
    : store.getAppState(state, "roomChatColor");

  return {
    characterId,
    pickedColor,
    open: store.getAppState(state, "openRoomColorPicker"),
  };
};

type ColorPickerState = ReturnType<typeof selectColorPickerState>;

const ColorPicker = () => {
  const state = useAppSelector(selectColorPickerState, shallowEqual);
  const $ = useEnhance(state);
  return (
    <Dialog open={state.open} onClose={$.onClose}>
      <DialogContent style={{ padding: 0 }}>
        <PickerField>
          <TwitterPicker
            color={state.pickedColor}
            onChange={(color: unknown) => console.log(color)}
            onChangeComplete={$.onChange}
            triangle={"hide"}
            styles={{
              default: {
                card: {
                  background: "transparent",
                  border: "none",
                  boxShadow: "none",
                  borderRadius: "unset",
                },
                input: {
                  height: "30px",
                },
              },
            }}
            colors={[
              "#222222" /* theme_color  */,
              material.red["500"],
              material.pink["500"],
              material.purple["500"],
              material.deepPurple["500"],
              material.indigo["500"],
              material.blue["500"],
              material.lightBlue["500"],
              material.cyan["500"],
              material.teal["500"],
              material.green["500"],
              material.lightGreen["500"],
              material.lime["500"],
              material.yellow["500"],
              material.amber["500"],
              material.orange["500"],
              material.deepOrange["500"],
              material.brown["500"],
              material.blueGrey["500"],
              material.grey["500"],
              material.grey["300"],
            ]}
          />
        </PickerField>
      </DialogContent>
    </Dialog>
  );
};

const PickerField = styled.div`
  display: block;
  padding-bottom: 8px;
`;

const useEnhance = (props: ColorPickerState) => {
  const dispatch = useAppDispatch();
  const onClose = useCallback(() => {
    dispatch(
      store.appStateMutate((state) => {
        state.openRoomColorPicker = false;
      })
    );
  }, [dispatch]);

  const onChange = useCallback(
    (color) => {
      if (props.characterId) {
        dispatch(
          store.updateRoomCharacter(props.characterId, {
            color: color.hex,
          })
        );
        dispatch(
          addUndoUpdateCharacter(props.characterId, {
            color: color.hex,
          })
        );
      } else {
        dispatch(
          store.appStateMutate((state) => {
            state.roomChatColor = color.hex;
          })
        );
      }
    },
    [props.characterId, dispatch]
  );

  return {
    onClose,
    onChange,
  };
};

export default memo(ColorPicker);
